"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Metrics = void 0;
var MetricsTimer_1 = require("./MetricsTimer");
var Logger_1 = require("../Logger");
var Metrics = (function () {
    function Metrics() {
        this.startupTimer = new MetricsTimer_1.MetricsTimer();
        this.totalPausedTimer = new MetricsTimer_1.MetricsTimer();
        this.totalPlayingTimer = new MetricsTimer_1.MetricsTimer();
        this.totalSeekingTimer = new MetricsTimer_1.MetricsTimer();
        this.totalWaitingTimer = new MetricsTimer_1.MetricsTimer();
        this.isStarting = false;
        this.isSeeking = false;
        this.isWaiting = false;
        this.bandwidthEstimate = undefined;
        this.liveLatency = undefined;
        this.droppedFrames = 0;
        this.totalDownloadedBytes = 0;
        this.bufferAhead = undefined;
    }
    Object.defineProperty(Metrics.prototype, "startupTime", {
        get: function () {
            return this.startupTimer.totalTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Metrics.prototype, "totalPausedTime", {
        get: function () {
            return this.totalPausedTimer.totalTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Metrics.prototype, "totalPlayingTime", {
        get: function () {
            return this.totalPlayingTimer.totalTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Metrics.prototype, "totalSeekingTime", {
        get: function () {
            return this.totalSeekingTimer.totalTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Metrics.prototype, "totalWaitingTime", {
        get: function () {
            return this.totalWaitingTimer.totalTime;
        },
        enumerable: false,
        configurable: true
    });
    Metrics.prototype.reset = function () {
        Logger_1.Logger.debug('Metrics.reset()');
        this.isStarting = false;
        this.isSeeking = false;
        this.isWaiting = false;
        this.startupTimer.reset();
        this.totalPausedTimer.reset();
        this.totalPlayingTimer.reset();
        this.totalSeekingTimer.reset();
        this.totalWaitingTimer.reset();
        this.bandwidthEstimate = undefined;
        this.liveLatency = undefined;
        this.droppedFrames = 0;
        this.totalDownloadedBytes = 0;
        this.bufferAhead = undefined;
    };
    Metrics.prototype.attach = function (player) {
        var _this = this;
        Logger_1.Logger.debug('Metrics.attach()');
        this.player = player;
        player.addEventListener('pause', function () {
            Logger_1.Logger.debug('Metrics.onPause()');
            _this.updateTimers();
        });
        player.addEventListener('waiting', function () {
            Logger_1.Logger.debug('Metrics.onWaiting()');
            _this.isWaiting = true;
            _this.updateTimers();
        });
        player.addEventListener('playing', function () {
            Logger_1.Logger.debug('Metrics.onPlaying()');
            _this.isStarting = false;
            _this.isWaiting = false;
            _this.isSeeking = false;
            _this.updateTimers();
        });
        player.addEventListener('canplay', function () {
            Logger_1.Logger.debug('Metrics.onCanPlay()');
            _this.isStarting = false;
            _this.isWaiting = false;
            _this.isSeeking = false;
            _this.updateTimers();
        });
        player.addEventListener('seeking', function () {
            Logger_1.Logger.debug('Metrics.onSeeking()');
            _this.isSeeking = true;
            _this.updateTimers();
        });
        player.addEventListener('seeked', function () {
            Logger_1.Logger.debug('Metrics.onSeeked()');
            _this.isSeeking = true;
            _this.updateTimers();
        });
        player.addEventListener('progress', function () {
            _this.updateBufferedRange();
        });
    };
    Metrics.prototype.load = function () {
        Logger_1.Logger.debug('Metrics.load()');
        this.reset();
        this.isStarting = true;
        this.updateTimers();
    };
    Metrics.prototype.unload = function () {
        Logger_1.Logger.debug('Metrics.unload()');
        this.startupTimer.active = false;
        this.totalPausedTimer.active = false;
        this.totalPlayingTimer.active = false;
        this.totalSeekingTimer.active = false;
        this.totalWaitingTimer.active = false;
    };
    Metrics.prototype.updateBufferedRange = function () {
        var player = this.player;
        var currentTime = player.currentTime;
        this.bufferAhead = player.bufferedRanges
            .filter(function (range) { return range.start <= currentTime && range.end > currentTime; })
            .map(function (range) { return range.end - currentTime; })
            .reduce(function (acc, time) { return acc + time; }, 0);
    };
    Metrics.prototype.updateTimers = function () {
        var isStarting = false;
        var isPaused = false;
        var isPlaying = false;
        var isWaiting = false;
        var isSeeking = false;
        if (this.isStarting) {
            isStarting = true;
        }
        else if (this.player.paused) {
            isPaused = true;
        }
        else if (this.isSeeking) {
            isSeeking = true;
        }
        else if (this.isWaiting) {
            isWaiting = true;
        }
        else {
            isPlaying = true;
        }
        this.startupTimer.active = isStarting;
        this.totalPausedTimer.active = isPaused;
        this.totalPlayingTimer.active = isPlaying;
        this.totalSeekingTimer.active = isSeeking;
        this.totalWaitingTimer.active = isWaiting;
    };
    Metrics.prototype.detach = function () {
        this.player = undefined;
    };
    Metrics.prototype.snapshot = function () {
        return {
            bandwidthEstimate: this.bandwidthEstimate,
            liveLatency: this.liveLatency,
            droppedFrames: this.droppedFrames,
            totalDownloadedBytes: this.totalDownloadedBytes,
            bufferAhead: this.bufferAhead,
            startupTime: this.startupTime,
            totalPausedTime: this.totalPausedTime,
            totalPlayingTime: this.totalPlayingTime,
            totalSeekingTime: this.totalSeekingTime,
            totalWaitingTime: this.totalWaitingTime,
        };
    };
    return Metrics;
}());
exports.Metrics = Metrics;
//# sourceMappingURL=index.js.map